import React from 'react';
import { InputAdornment, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

function FilterSelect({ label, value, onChange, options, className = '' }) {
  const selectStyles = {
    '& .MuiOutlinedInput-root': {
      color: 'white',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.2)' },
      '&:hover fieldset': { borderColor: '#F6911D' },
      '&.Mui-focused fieldset': { borderColor: '#F6911D' },
    },
    '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.6)' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#F6911D' },
    '& .MuiSvgIcon-root': { color: 'rgba(255, 255, 255, 0.6)' },
  };

  return (
    <FormControl fullWidth sx={selectStyles} className={className}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        startAdornment={
          <InputAdornment position="start">
            <FilterListIcon sx={{ color: 'rgba(255, 255, 255, 0.5)', ml: -0.5 }} />
          </InputAdornment>
        }
      >
        <MenuItem value="">
          <em>All</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default FilterSelect;
